import { GridLayout } from "@/design-system/salt";

interface StatsCardGridProps {
  children: React.ReactNode;
  /** Number of columns at largest breakpoint. Default 4. */
  columns?: 2 | 3 | 4;
  /** Compact mode: 2-col base on mobile, tighter gap */
  compact?: boolean;
  className?: string;
}

/** Stats Card Grid component. */
export function StatsCardGrid({
  children,
  columns = 4,
  compact = false,
  className,
}: StatsCardGridProps) {
  const responsiveColumns = compact
    ? {
        2: { xs: 2, sm: 2 },
        3: { xs: 2, sm: 3 },
        4: { xs: 2, sm: 4 },
      }[columns]
    : {
        2: { xs: 1, sm: 2 },
        3: { xs: 1, sm: 2, md: 3 },
        4: { xs: 1, sm: 2, md: 4 },
      }[columns];

  return (
    <GridLayout
      className={className}
      columns={responsiveColumns}
      gap={compact ? 1 : 2}
    >
      {children}
    </GridLayout>
  );
}
